/* unplugin-vue-components disabled */import { render } from "./ArchiveDetails.vue?vue&type=template&id=a803cdf0&scoped=true"
import script from "./ArchiveDetails.vue?vue&type=script&lang=js"
export * from "./ArchiveDetails.vue?vue&type=script&lang=js"

import "./ArchiveDetails.vue?vue&type=style&index=0&id=a803cdf0&lang=less&scoped=true"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a803cdf0"]])

export default __exports__